import React from 'react';

export const RRContext = React.createContext({});
